import { FunctionComponent } from 'react';

import LayoutContainer from 'components/layout/LayoutContainer';

import StyledComponent from './styles';
import { Props } from './types';

const SectionsHeroBlack: FunctionComponent<Props> = ({ headline, subheadline }) => {
    return (
        <StyledComponent className="sections-hero-black">
            <LayoutContainer className="hero-wrapper">
                <header className="hero-header">
                    <h1 className="hero-header-headline">
                        {headline}
                    </h1>
                    <p className="hero-header-subheadline">
                        {subheadline}
                    </p>
                </header>
            </LayoutContainer>
        </StyledComponent>
    );
};

export default SectionsHeroBlack;
